module.exports = __webpack_public_path__ + "img/vertical_6_5_7042.b7ea8bfc.png";